import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * Renders a loading indicator using CircularProgress from @mui/material.
 *
 * @returns {React.Component} The LoadingIndicator component.
 */
const LoadingIndicator = () => (
  <div className='loading-indicator-container'>
    <CircularProgress sx={{ color: '#FF6600' }} />
  </div>
);

export default LoadingIndicator;
